import { useState, useEffect, useCallback } from 'react'
import { get, post, put, del } from '../utils/api'

export function useApi(path, params = null, deps = []) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const reload = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const result = await get(path, params)
      setData(result)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }, [path, JSON.stringify(params)])

  useEffect(() => { reload() }, [reload, ...deps])

  return { data, loading, error, reload, setData }
}

export { get, post, put, del }
